import React from 'react';

const Tamil = () => {
  return (
    <div>
      Tamil
      Tamil
    </div>
  );
}

export default Tamil;
